import { render, staticRenderFns } from "./inspection.vue?vue&type=template&id=4b9d8166"
import script from "./inspection.vue?vue&type=script&lang=js"
export * from "./inspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports